import { jsx } from '@emotion/core';
import { Type, Button, GRID, COLORS } from '../../';
import { useLocalization } from '../../localization';
import * as languages from './localization';
export var PageError = function PageError() {
  var strings = useLocalization(languages).strings;
  return jsx("div", {
    css: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: GRID.medium,
      background: COLORS.grays.background,
      minHeight: '100vh'
    }
  }, jsx(Type.H5, {
    css: {
      marginTop: GRID.small
    }
  }, strings.sorry), jsx(Button, {
    onClick: function onClick() {
      return window.location.reload();
    }
  }, strings.tryagain));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/index.js
// module id = 1171
// module chunks = 0